import { Component } from '@angular/core';

@Component({
  selector: 'app-proceedings-button24',
  templateUrl: './proceedings-button24.component.html',
  styleUrl: './proceedings-button24.component.css'
})
export class ProceedingsButton24Component {

}
